<template>
  <b-modal id="modal-add-edit-local-votacion" size="md" :no-close-on-backdrop="true" :no-close-on-esc="true" v-model="mostrarModal" dialog-class="modal-dialog-scrollable" v-if="mostrarModal" @close="handleModalClose">
    <template slot="modal-title">
      <div>
        <span class="font-weight-light"><i class=" fa fa-vote-yea fa-fw "></i>
          {{ procesoElectoral.procesoElectoralId ? "Editar" : "Agregar" }}
          proceso electoral
        </span>
      </div>
    </template>
    <!--Contenido de modal de | ID :
    {{ localVotacionId }}-->
    <b-form id="frm-add-edit-local-votacion">
      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" role="tab" class="py-2">
          <b-button block variant="link" v-b-toggle.pe-general class="text-left p-0">
            <i class="fa fa-cog mr-2"></i> Datos generales
          </b-button>
        </b-card-header>
        <b-collapse id="pe-general" visible accordion="pe-accordion" role="tabpanel">
          <b-card-body>
            <div class="row pt-1">
              <div class="col-md-12">
                <label class="font-weight-bold">Nombre</label>
                <b-form-input id="input-1" v-model="procesoElectoral.nombre" required placeholder=""></b-form-input>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-md-12">
                <label class="font-weight-bold">Fecha de Inicio</label>
                <br />
                <input type="datetime-local" class="form-control" id="datetime-1" v-model="procesoElectoral.fechaInicio" required />
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-md-12">
                <label class="font-weight-bold">Fecha de Fin</label>
                <br />
                <input type="datetime-local" class="form-control" id="datetime-2" v-model="procesoElectoral.fechaFin" required />
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" role="tab" class="py-2">
          <b-button block variant="link" v-b-toggle.pe-turno-1 class="text-left p-0">
            <i class="fa fa-clock mr-2"></i> Turno 1
          </b-button>
        </b-card-header>
        <b-collapse id="pe-turno-1" accordion="pe-accordion" role="tabpanel">
          <b-card-body>
            <div class="row pt-1">
              <div class="col-md-6">
                <label class="font-weight-bold">Inicio</label>
                <input type="datetime-local" class="form-control" id="datetime-3" v-model="procesoElectoral.fechaInicioTurno1" required />
              </div>
              <div class="col-md-6 pt-3 pt-md-0">
                <label class="font-weight-bold">Fin</label>
                <input type="datetime-local" class="form-control" id="datetime-4" v-model="procesoElectoral.fechaFinTurno1" required />
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" role="tab" class="py-2">
          <b-button block variant="link" v-b-toggle.pe-turno-2 class="text-left p-0">
            <i class="fa fa-clock mr-2"></i> Turno 2
          </b-button>
        </b-card-header>
        <b-collapse id="pe-turno-2" accordion="pe-accordion" role="tabpanel">
          <b-card-body>
            <div class="row pt-1">
              <div class="col-md-6">
                <label class="font-weight-bold">Inicio</label>
                <input type="datetime-local" class="form-control" id="datetime-5" v-model="procesoElectoral.fechaInicioTurno2" required />
              </div>
              <div class="col-md-6 pt-3 pt-md-0">
                <label class="font-weight-bold">Fin</label>
                <input type="datetime-local" class="form-control" id="datetime-6" v-model="procesoElectoral.fechaFinTurno2" required />
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" role="tab" class="py-2">
          <b-button block variant="link" v-b-toggle.pe-turno-3 class="text-left p-0">
            <i class="fa fa-clock mr-2"></i> Turno 3
          </b-button>
        </b-card-header>
        <b-collapse id="pe-turno-3" accordion="pe-accordion" role="tabpanel">
          <b-card-body>
            <div class="row pt-1">
              <div class="col-md-6">
                <label class="font-weight-bold">Inicio</label>
              </div>
              <div class="col-md-6 pt-3 pt-md-0">
                <label class="font-weight-bold">Fin</label>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" role="tab" class="py-2">
          <b-button block variant="link" v-b-toggle.pe-turno-4 class="text-left p-0">
            <i class="fa fa-clock mr-2"></i> Turno 4
          </b-button>
        </b-card-header>
        <b-collapse id="pe-turno-4" accordion="pe-accordion" role="tabpanel">
          <b-card-body>
            <div class="row pt-1">
              <div class="col-md-6">
                <label class="font-weight-bold">Inicio</label>
              </div>
              <div class="col-md-6 pt-3 pt-md-0">
                <label class="font-weight-bold">Fin</label>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>

      <b-card no-body class="mb-2">
        <b-card-header header-tag="header" role="tab" class="py-2">
          <b-button block variant="link" v-b-toggle.pe-config class="text-left p-0">
            <i class="fa fa-sliders-h mr-2"></i> Configuración
          </b-button>
        </b-card-header>
        <b-collapse id="pe-config" accordion="pe-accordion" role="tabpanel">
          <b-card-body>
            <div class="row pt-1">
              <div class="col-md-6">
                <label class="font-weight-bold">Edición por turnos (min. antes)</label>
                <b-form-input id="input-2" v-model="procesoElectoral.edicionTurnoMinutosAntes" required placeholder="Minutos..."></b-form-input>
              </div>
              <div class="col-md-6 pt-3 pt-md-0">
                <label class="font-weight-bold">Edición por turnos (min. después)</label>
                <b-form-input id="input-3" v-model="procesoElectoral.edicionTurnoMinutosDespues" required placeholder="Minutos..."></b-form-input>
              </div>
            </div>
            <div class="row pt-3">
              <div class="col-md-6">
                <label class="font-weight-bold">Orden</label>
                <b-form-input id="input-4" v-model="procesoElectoral.orden" required placeholder=""></b-form-input>
              </div>
              <div class="col-md-6 pt-3 pt-md-0" v-if="procesoElectoral.esActual == false">
                <label class="font-weight-bold d-block">Eliminar</label>
                <b-form-checkbox id="checkbox-2" size="lg" v-model="procesoElectoral.esEliminado"> </b-form-checkbox>
              </div>
            </div>
          </b-card-body>
        </b-collapse>
      </b-card>
    </b-form>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="handleModalClose()"><i class="fa fa-ban"></i> Cancelar</button>
      <button type="button" class="btn btn-primary font-weight-bold" @click.prevent="doSave()"><i class="fa fa-save"></i> Guardar</button>
    </template>
  </b-modal>
</template>

<style></style>

<script>
export default {
  name: "add-edit-proceso-electoral",
  components: {},
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    procesoElectoralId: {
      type: Number,
    },
  },
  data: () => ({
    mostrarModal: true,
    procesoElectoral: {
      procesoElectoralId: null,
      nombre: "",
      fechaInicio: null,
      fechaFin: null,
      fechaInicioTurno1: null,
      fechaInicioTurno2: null,
      fechaFinTurno1: null,
      fechaFinTurno2: null,
      edicionTurnoMinutosAntes: null,
      edicionTurnoMinutosDespues: null,
      orden: null,
      esActual: false,
      esEliminado: false,
    },
  }),
  computed: {},
  methods: {
    handleModalClose: async function (event) {
      if (event) {
        event.preventDefault();
      }

      /*var resp = await this.sweetConfirm("¿Desea cerrar esta ventana?");
      if (resp) {
        this.mostrarModal = false;
      }*/

      this.mostrarModal = false;
    },
    doSave: async function () {
      if (!(await this.sweetConfirm("¿Desea guardar los datos?"))) {
        return;
      }

      if (!this.isFormValid("frm-add-edit-local-votacion")) {
        return this.sweetAlert("Hay campos con valores incorrectos. Revise los datos ingresados.");
      }

      var model = {
        ...this.procesoElectoral,
      };

      this.estaGuardando = true;
      await this.$http.post(this.apiRoute("ElectoralProcess", "AddEditProcesoElectoral"), model).then(function (response) {
        if (!this.procesarRespuestaErrorDefecto(response)) {
          this.sweetAlert(response.body.message, "success");
        }
      }, this.mostrarMensajeExcepcionVueResource);

      this.estaGuardando = false;
      this.mostrarModal = false;
    },
    fetchProcesoElectoral: function (procesoElectoralId) {
      if (procesoElectoralId) {
        this.$http
          .get(this.apiRoute("ElectoralProcess", "GetProcesoElectoralById"), {
            params: {
              ProcesoElectoralId: procesoElectoralId,
            },
          })
          .then(function (response) {
            this.procesoElectoral = response.body.data;
          });
      }
    },
  },
  watch: {
    mostrarModal: function (newValue) {
      this.$emit("input", newValue);
    },
  },
  mounted: function () {
    this.mostrarModal = this.value;
    this.procesoElectoral.procesoElectoralId = this.procesoElectoralId;
    this.initParsley();
    this.fetchProcesoElectoral(this.procesoElectoral.procesoElectoralId);
  },
  destoyed: function () { },
};
</script>
